/*
 * AddStudent Messages
 *
 * This contains all the text for the AddStudent component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
    inviteTeacher: {
        id: 'app.components.AddTeacher.inviteTeacher',
        defaultMessage: 'Invite teacher'
    },
    title: {
        id: 'app.components.AddTeacher.title',
        defaultMessage: 'Title'
    },
    firstName: {
        id: 'app.components.AddTeacher.firstName',
        defaultMessage: 'First name'
    },
    surname: {
        id: 'app.components.AddTeacher.surname',
        defaultMessage: 'Surname'
    },
    emailAddress: {
        id: 'app.components.AddTeacher.emailAddress',
        defaultMessage: 'Email Address'
    },
    classroomList: {
        id: 'app.components.AddTeacher.classroomList',
        defaultMessage: 'Select a {product} class'
    },
    teacherTitleNone: {
        id: 'app.components.EditTeacher.teachertTitle.none',
        defaultMessage: 'None'
    },
    teacherTitleNone_key: {
        id: 'app.components.EditTeacher.teachertTitle.none.key',
        defaultMessage: 'none'
    }
});



// WEBPACK FOOTER //
// ./app/components/add-teacher/messages.js